import * as amplitude from '@amplitude/analytics-browser';
import mixpanel from 'mixpanel-browser';

const AMPLITUDE_KEY = import.meta.env.VITE_AMPLITUDE_API_KEY ?? '';
const MIXPANEL_TOKEN = import.meta.env.VITE_MIXPANEL_TOKEN ?? '';

let amplitudeInitialized = false;
let mixpanelInitialized = false;

export function initAnalytics(): void {
  if (!amplitudeInitialized && AMPLITUDE_KEY) {
    amplitude.init(AMPLITUDE_KEY, undefined, {
      defaultTracking: {
        sessions: true,
        pageViews: true,
        formInteractions: false,
        fileDownloads: false,
      },
    });
    amplitudeInitialized = true;
  }

  if (!mixpanelInitialized && MIXPANEL_TOKEN) {
    mixpanel.init(MIXPANEL_TOKEN, {
      debug: import.meta.env.DEV,
      persistence: 'localStorage',
      track_pageview: true,
    });
    mixpanelInitialized = true;
  }
}

export function track(event: string, props?: Record<string, unknown>): void {
  if (amplitudeInitialized) amplitude.track(event, props);
  if (mixpanelInitialized) mixpanel.track(event, props);
}

export const events = {
  homeView: 'home.view',
  trialStart: 'trial.start',
  trialCheckoutSubmit: 'trial.checkout.submit',
  trialCheckoutError: 'trial.checkout.error',
  trialSuccess: 'trial.success',
  joinView: 'join.view',
  joinValidateCode: 'join.validate.code',
  joinCheckoutSubmit: 'join.checkout.submit',
  joinCheckoutError: 'join.checkout.error',
  joinSuccess: 'join.success',
  membershipSignupStep1: 'membership.signup.step_1_programs.view',
  membershipSignupStep2: 'membership.signup.step_2_sign_in.view',
  membershipSignupStep3: 'membership.signup.step_3_waiver_id.view',
  membershipSignupStep4: 'membership.signup.step_4_confirm_pay.view',
  membershipSignupConfirmation: 'membership.signup.confirmation.view',
  trialSignupStep1: 'trial.signup.step_1_class.view',
  trialSignupStep2: 'trial.signup.step_2_sign_in.view',
  trialSignupStep3: 'trial.signup.step_3_waiver_id.view',
  trialSignupStep4: 'trial.signup.step_4_confirm_pay.view',
  trialSignupConfirmation: 'trial.signup.confirmation.view',
  contactSubmit: 'contact.submit',
} as const;
